<template>

  <b-row v-if="esGastro">
    <b-col>
      <b-card
        
        no-body
        :class="{ 'open': visibleBody }"
      >

        <b-card-header
          :class="{ 'collapsed': !visibleBody }"
          :aria-expanded="visibleBody ? 'true' : 'false'"
          role="tab"
          data-toggle="collapse"
          @click="onVisibleBody(!visibleBody)"
          style="padding: 0 1px; color: black; font:45px; cursor: pointer;"
        >
          <span class="lead collapse-title">
            <strong>SEMIOLOGIA GASTROENTEROLOGICA</strong>
          </span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >
          <b-card-body style="padding: 2.5rem 1.5rem">

            <b-row>
              <b-col>
                <h5>Sintomas:</h5>
                <v-select
                  placeholder="Seleccione una o mas opciones"
                  :options="sintomasOpts"
                  :reduce="option => option"
                  label="text"
                  :multiple="true"
                  taggable
                  @input="newArray => sintomas = onAddNewOpt(newArray)"
                />
                
              </b-col>
            </b-row>

            <SintomasDolor v-if="sintomas.some(item => item.value === 'dolor')"/>

            <SintomasPirosis v-if="sintomas.some(item => item.value === 'pirosis')"/>

            <SintomasEvacuaciones v-if="sintomas.some(item => item.value === 'evacuaciones_intestinales')"/>

            <SintomasOtros :sintomasPrincipal="sintomas"/>  

            <SintomasOtros2 :sintomasPrincipal="sintomas"/>

          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>
  
</template>

<script>
import { mapState }  from 'vuex';
import { addNewOpt } from '@/shared/helpers';
import vSelect from "vue-select";
import SintomasDolor        from './SintomasDolor.vue';
import SintomasPirosis      from './SintomasPirosis.vue';
import SintomasEvacuaciones from './SintomasEvacuaciones.vue';
import SintomasOtros        from './SintomasOtros.vue';
import SintomasOtros2       from './SintomasOtros2.vue';


export default {
  name: "SemiologiaGastroentereologica",

  components: {
    vSelect,
    SintomasDolor,
    SintomasPirosis,
    SintomasEvacuaciones,
    SintomasOtros,
    SintomasOtros2
  },

  data() {
    return {
      visibleBody: true,
      sintomas:[],

      sintomasOpts : [
        { value: "dolor",         text: "Dolor" },
        { value: "pirosis",       text: "Pirosis" },
        { value: "rejurgitacion", text: "Rejurgitación" },
        { value: "evacuaciones_intestinales", text: "Evacuaciones intestinales" },
        { value: "nauseas",       text: "Nauseas" },
        { value: "vomitos",       text: "Vomitos" },
        { value: "hematemesis",   text: "Hematemesis" },
        { value: "ictericia",     text: "Ictericia" },
        { value: "distension_abdominal", text: "Distensión abdominal" },
        { value: "eructos",       text: "Eructos" },
        { value: "sintomas_asociados", text: "Sintomas asociados a cuadros" },
      ]

    }
  },

  methods: {
    onVisibleBody(value) {
      this.visibleBody = value;
    },
    
    onAddNewOpt(newArray) {
      return addNewOpt(newArray);
    },
  },



  watch: {
    
    sintomas:{
      deep: true,
      handler(newValue){
        this.$store.commit("setGastro", { sintomas:newValue });
      }
    },

    stSemGastro:{
      deep: true,
      handler(newValue){
        const semiologia = { tipo:'gastro', data:newValue }
        this.$store.commit("setSemiologia", semiologia );
      }
    },
  },

  computed: {
    ...mapState({
      stSemGastro: state => state.atencionCita.semiologias?.semGastro,
      stDataDoctor: state => state.atencionCita.dataCita?.doctor
    }),

    esGastro(){
      return this.stDataDoctor?.especialidad?.codEsp === '0000000515';
    },
  },

}
</script>
